import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Container, Dropdown, Image, Icon, Header } from 'semantic-ui-react';
import { base } from '../helper/base-helper.js';

import AuthModal from './AuthModal';

class MenuBar extends Component {
  constructor() {
    super();

    this.renderBackToSearch = this.renderBackToSearch.bind(this);
    this.renderSearchLink = this.renderSearchLink.bind(this);
    this.renderLoggedInMenu = this.renderLoggedInMenu.bind(this);
    this.renderAdminLink = this.renderAdminLink.bind(this);

    this.state = {
      showSearch: true,
      showBackToSearch: false,
    }
  }

  componentWillMount() {
    const urlPattern = this.props.match.path;

    switch (urlPattern) {
      case "/":
      this.setState({
        showSearch: false
      });
      break;
      case "/:channelURL/:actionURL":
        this.setState({
          showSearch: false,
          showBackToSearch: true
        });
        break;
      default:
        this.setState({
          showSearch: true
        });
    }

  }

  renderBackToSearch() {
    return (
      <Menu.Item as={Link} to='/' name='search' active>
        New Search
      </Menu.Item>
    )
  }

  renderSearchLink() {
    return (
      <Menu.Item as={Link} to='/' name='search'>
        Search
      </Menu.Item>
    )
  }

  renderAdminLink() {
    return (
      <div>
        <Dropdown.Item as={Link} to='/admin'>
        Admin
        <Icon name='lock' />
        </Dropdown.Item>
      </div>
    )
  }

  renderLoggedInMenu(user) {
    const adminVisible = user.role ? (user.role.admin || user.role.editor) : '';
    const placeholder = 'https://placehold.it/140x140?text=photo';
    const photoURL = (user.photoURL) ? user.photoURL : placeholder;

    return (
      <Menu.Item>
        <Dropdown
          icon={null}
          pointing='top right'
          trigger={
            <Image size='mini' shape='circular' src={photoURL}/>
          }>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to='/profile'>Profile</Dropdown.Item>
            <Dropdown.Item as={Link} to='/notifications'>Notification Centre</Dropdown.Item>
            <Dropdown.Item>Feedback</Dropdown.Item>
            <Dropdown.Divider />
            { adminVisible
              ? this.renderAdminLink()
              : ''}
            <Dropdown.Divider />
            <Dropdown.Item
              onClick={() => {
                base.unauth();
              }}>
              Log Out</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Item>
    );
  }

  //check Menu.Item is on URL it points to. Is used to set Menu.Item active.
  //Also I need prevent clicks on an active link adds current page to history
  //which is not working at the moment.
  checkActiveClickable(location) {
    return (this.props.location.pathname === location)
  }

  render() {
    const locations = {
      search: '/',
      about: '/about',
      signUp: '/signup',
      profile: '/profile',
      admin: '/admin'
    };

    return (
      <Container>
        <Menu pointing secondary className="menuBar">

          {/* Render a general search link when in content sub pages */}
          {(this.state.showSearch) ? this.renderSearchLink() : ''}

          {/* Render a back to search link when in search related sub pages */}
          {(this.state.showBackToSearch) ? this.renderBackToSearch() : ''}

          <Menu.Item
            as={Link}
            to='/about'
            name='about'
            active={this.checkActiveClickable(locations.about)}>
            About
          </Menu.Item>

          <Menu.Item
            position='right'
            link>
            <Header textAlign='right' size='tiny' color='blue' content='$ · £ · €'/>
          </Menu.Item>

          {/* Show the logged in Menu or Sign-Up/Log-In link */}
          {(this.props.user)
            ? this.renderLoggedInMenu(this.props.user)
            : <AuthModal /> }

        </Menu>
      </Container>
    )
  }
}

export default MenuBar;



// WEBPACK FOOTER //
// ./src/components/MenuBar.js